import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import has from 'lodash/has';
import get from 'lodash/get';
import values from 'lodash/values';

function mapStateToProps(state,props){
  //TODO: Connect Redux state to AccountTransferHistory

  const transfers = get(state,['accounting','accounts',props.accountId,'history'],[])
    // .filter((a) => a.toAccountId === props.accountId || a.fromAccountId === props.accountId)
    .sort((a,b) => b.lastModifiedDate - a.lastModifiedDate);

  return {
    balance:get(state,['accounting','accounts',props.accountId,'balance'],0),
    transfers:transfers
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to AccountTransferHistory
  return bindActionCreators({},dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/AccountTransferHistory/connect.js